import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationFormCoordinatorService } from '../../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

@Component({
    selector: 'app-configuration-form-file-linebased-all-attributes',
    templateUrl: './configuration-form-file-linebased-all-attributes.component.html',
    styleUrls: ['./configuration-form-file-linebased-all-attributes.component.scss'],
    imports: [ReactiveFormsModule, YesNoGroupButtonComponent, TranslateModule]
})
export class ConfigurationFormFileLinebasedAllAttributesComponent {
  public get configurationFormLinebasedAllAttributes(): UntypedFormGroup {
    return this.configurationFormService.configurationFormFileLineBasedAllAttributes;
  }
  
  constructor(
    private configurationFormService: ConfigurationFormCoordinatorService) {
  }
}
